
import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { JwtService } from 'src/app/jwt.service';
import { ClienteManager } from 'src/app/managers/cliente-manager';
import { SnackbarManager } from 'src/app/managers/snackbar-manager';
import { ConfigService } from 'src/app/services/config.service';
import { FilialService } from './../../services/filial.service';
import { CORE_IMPORTS } from 'src/app/providers/module-providers';

@Component({
    standalone: true,
    selector: 'app-card-login',
    templateUrl: './card-login.component.html',
    styleUrls: ['./card-login.component.css'],
    imports: [CORE_IMPORTS]
    
})
export class CardLoginComponent {
    public btnLoginDesabilado = false;
    protected ngUnsubscribe: Subject<void> = new Subject<void>();
    public cpf_cnpj: string;

    constructor(
        private router: Router,
        private jwtService: JwtService,
        private clienteManager: ClienteManager,
        private snackBarManager: SnackbarManager,
        private filialService: FilialService,
        private config: ConfigService,                
    ) {
    }

    login(usuario: string, senha: string) {
        const urlRedirect = localStorage.getItem('urlRedirect')
        usuario = this.removerMascara(usuario);
        this.btnLoginDesabilado = true;
        if (usuario == '' || senha == '') {
            this.btnLoginDesabilado = false;
            this.snackBarManager.openSnackBar('Usuario ou senha inválido.', 'Fechar', 2000);
            return;
        }
        this.jwtService.login(usuario, senha).subscribe((res) => {
            if (res['status'] == false) {
                this.btnLoginDesabilado = false;
                this.snackBarManager.openSnackBar(res['mensagem'], 'Fechar', 2000);
            } else {
                this.config.cdFilial = res['filial'];
                localStorage.setItem('access_token', res['access_token']);
                localStorage.setItem('expires_at', res['expires_at']);
                localStorage.setItem('cd_usuario', res['cd_usuario']);
                localStorage.setItem('cd_cliente', res['cd_cliente']);
                localStorage.setItem('filial', res['filial']);
                localStorage.setItem('expires_at_seconds', res['expires_at_seconds']);                
                this.clienteManager.getClienteFilial(Number.parseInt(localStorage.getItem('filial')));                
                this.filialService.getFiliais();
                this.jwtService.temAcesso().subscribe((r: boolean) => {
                    if(!r){
                        this.snackBarManager.openSnackBar('Usuário não possui acesso ao Portal', 'Fechar', 2000);
                        this.jwtService.logout();
                        return
                    }
                    if (Number.parseInt(localStorage.getItem('cd_cliente')) != 0) {
                        this.clienteManager.getCliente();
                        if(urlRedirect){
                            this.router.navigateByUrl(urlRedirect);
                            localStorage.removeItem('urlRedirect');
                        }else{
                            this.router.navigateByUrl('/home');
                        }
                    } else {
                        if(urlRedirect){
                            this.router.navigateByUrl(urlRedirect);
                            localStorage.removeItem('urlRedirect');
                        }else{
                            this.router.navigateByUrl('/home');
                        }
                    }

                },
                (error: HttpErrorResponse) => {
                    this.btnLoginDesabilado = false;
                    this.snackBarManager.openSnackBar(error.error, 'Fechar', 2000);
                }
                )
                
            }
        }, (error: HttpErrorResponse) => {
            this.btnLoginDesabilado = false;
            this.snackBarManager.openSnackBar((error.status == 0 ? "Não foi possível estabeler conexão com o servidor" : error.error), 'Fechar', 2000);
        });
    }

    getCpfCnpjMask() {
        if (this.cpf_cnpj == undefined) return;

        const raw = this.removerMascara(this.cpf_cnpj).toUpperCase();
        this.cpf_cnpj = raw;

        if (!/^[A-Z0-9]*$/.test(raw)) return;

        if (raw.length > 12 && /[^0-9]/.test(raw.substring(12))) return;

        const isAlfanumerico = /[A-Z]/.test(raw);

        if (isAlfanumerico || raw.length > 11) {
            if (raw.length <= 2)  return this.cpf_cnpj = raw;
            if (raw.length <= 5)  return this.cpf_cnpj = raw.replace(/^([A-Z0-9]{2})([A-Z0-9]{1,3})/, "$1.$2");
            if (raw.length <= 8)  return this.cpf_cnpj = raw.replace(/^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{1,3})/, "$1.$2.$3");
            if (raw.length <= 12) return this.cpf_cnpj = raw.replace(/^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{1,4})/, "$1.$2.$3/$4");
            return this.cpf_cnpj = raw.replace(/^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{1,2})/, "$1.$2.$3/$4-$5");
        }

        if (raw.length == 3)       return this.cpf_cnpj = raw.replace(/^(\d{3})/, "$1.");
        else if (raw.length == 4)  return this.cpf_cnpj = raw.replace(/^(\d{3})(\d{1})/, "$1.$2");
        else if (raw.length == 5)  return this.cpf_cnpj = raw.replace(/^(\d{3})(\d{2})/, "$1.$2");
        else if (raw.length == 6)  return this.cpf_cnpj = raw.replace(/^(\d{3})(\d{3})/, "$1.$2.");
        else if (raw.length == 7)  return this.cpf_cnpj = raw.replace(/^(\d{3})(\d{3})(\d{1})/, "$1.$2.$3");
        else if (raw.length == 8)  return this.cpf_cnpj = raw.replace(/^(\d{3})(\d{3})(\d{2})/, "$1.$2.$3");
        else if (raw.length == 9)  return this.cpf_cnpj = raw.replace(/^(\d{3})(\d{3})(\d{3})/, "$1.$2.$3-");
        else if (raw.length == 10) return this.cpf_cnpj = raw.replace(/^(\d{3})(\d{3})(\d{3})(\d{1})/, "$1.$2.$3-$4");
        else if (raw.length == 11) return this.cpf_cnpj = raw.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    }

    removerMascara(string: string) {
        return string = string.split('.').join('').split('-').join('').split('/').join('');
    }    
}